<ng-container *ngIf="company.billing as billing">
  <div class="subscription-preview">
    <div *ngIf="shouldShowWarning()" class="subscription-preview__notification">
      <div class="alert-message">
        <span class="icon-Info"></span>
        <span class="alert-message__content" [innerHTML]="warningMessage()"></span>
      </div>
    </div>
    <div class="divider"></div>
    <div class="subscription-preview__content">
      <div class="subscription-icon">
        <ng-container *ngIf="!trialNearEnd() else warningIconTemplate" [ngSwitch]="billing.status">
          <img *ngSwitchCase="BILLING_STATUS.PAST_DUE" src="./assets/images/red_flag.png" alt="" />
          <img *ngSwitchCase="BILLING_STATUS.SUSPENDED" src="./assets/images/warning.png" alt="" />
          <img *ngSwitchCase="BILLING_STATUS.UNSUBSCRIBED" src="./assets/images/warning.png" alt="" />
          <img *ngSwitchDefault src="./assets/images/sparkles.png" alt="" />
        </ng-container>
        <ng-template #warningIconTemplate>
          <img src="./assets/images/red_flag.png" alt="" />
        </ng-template>
      </div>
      <div class="subscription-details">
        <span class="subscription-title">{{ 'subscription.plan.' + billing.status + '.name' | translate | titlecase }}</span>
        <ng-container *ngIf="shouldShowTimer()">
          <app-subscription-countdown [billingInfo]="billing" class="subscription-timer" />
        </ng-container>
      </div>
      <div class="subscription-button">
        <ng-container [ngSwitch]="billing.status">
          <button *ngSwitchCase="BILLING_STATUS.FREE_TRIAL" class="btn-main btn-primary btn-xs" (click)="selectPlan(); $event.stopPropagation()">
            {{ 'subscription.plan_action.select_plan' | translate }}
          </button>

          <button *ngSwitchCase="BILLING_STATUS.SUSPENDED" class="btn-main btn-primary btn-xs" (click)="selectPlan(); $event.stopPropagation()">
            {{ 'subscription.plan_action.subscribe' | translate }}
          </button>

          <button *ngSwitchCase="BILLING_STATUS.UNSUBSCRIBED" class="btn-main btn-primary btn-xs" (click)="selectPlan(); $event.stopPropagation()">
            {{ 'subscription.plan_action.select_plan' | translate }}
          </button>

          <button *ngSwitchDefault class="btn-main btn-primary btn-xs" (click)="toSubscriptionPage(); $event.stopPropagation()">
            {{ 'subscription.plan_action.manage_plan' | translate }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
